"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageViewTracker = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const __1 = require("../");
function PageViewTracker({ registerOnPageView, getTrackPageData, context, }) {
    const analytics = (0, __1.useAnalytics)(context);
    const handler = (0, react_1.useCallback)(() => {
        const data = getTrackPageData?.() ?? {};
        analytics.trackPage(data);
    }, [analytics, getTrackPageData]);
    (0, react_1.useEffect)(handler, [handler]);
    (0, react_1.useEffect)(() => {
        const deregisterOnPageView = registerOnPageView(handler);
        return deregisterOnPageView;
    }, [registerOnPageView, handler]);
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.PageViewTracker = PageViewTracker;
//# sourceMappingURL=page-view-tracker.js.map